/**
 * @desc 获取的jsticket
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryJsApiTicketResponse>> {
  return defHttp.get({
    url: '/dingding/ticket',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryJsApiTicketResponse>> {
  return defHttp.get({
    url: '/mock/dingding/ticket',
  });
}
